import { Link, useLocation } from "react-router-dom";
import { Ticket } from "lucide-react";

const NAV = [
  { label: "Accueil", to: "/" },
  { label: "Concerts", to: "/#concerts" },
  { label: "Salles", to: "/#venues" },
  { label: "FAQ", to: "/#faq" },
  { label: "Contact", to: "/contact" },
];

export default function Header() {
  const { pathname } = useLocation();
  return (
    <header
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
          <span className="grid place-items-center w-8 h-8 bg-primary text-primary-foreground rounded-sm group-hover:rotate-3 transition-transform">
            <Ticket size={18} strokeWidth={2} />
          </span>
          <div className="flex flex-col leading-none">
            <span className="font-black tracking-tight text-base">SPECTRA</span>
            <span className="font-mono text-[10px] tracking-[0.25em] text-muted-foreground">LIVE · FRANCE</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.to}
              href={n.to}
              className={`text-sm hover:text-primary transition-colors ${
                pathname === n.to ? "text-primary" : "text-foreground/80"
              }`}
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href="/#concerts"
          className="hidden sm:inline-flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2 rounded-sm font-bold text-sm hover:brightness-110 transition"
          data-testid="header-cta-btn"
        >
          Voir les concerts
        </a>
      </div>
    </header>
  );
}
